import { DecoratorProps } from "./DecoratorProps";
import { LayoutProvidedReportDecoratorProps } from "./LayoutProvidedReportDecoratorProps";
import { PreviewDecorator } from "./PreviewDecorator";

/**
 * Decorator whose layout property contains report parameters.  That layout will be nested inside the decorator, which
 * constructs/includes Clear/Search buttons, as well as the ReportPreview panel.
 */
export class ReportDecorator extends PreviewDecorator implements DecoratorProps {
    constructor(props?: Partial<DecoratorProps>) {
        super(props);
        this.panelPreview.displaySingleResultInTabset = false;
    }

    protected override get layoutProvidedProps(): Partial<LayoutProvidedReportDecoratorProps> {
        return this.layout.reportDecoratorProps;
    }
}
